import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { addFormulaNote, getCustomFormula } from "../../actions/formulaAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
const NotePopup = ({ closePopup, previousNote, formulaId }) => {
  const dispatch = useDispatch();
  const [noteContent, setNoteContent] = useState(previousNote);
  const [showAddSection, setShowAddSection] = useState(false);

  const initialValues = {
    note: previousNote,
  };

  const validationSchema = Yup.object({
    note: Yup.string().nullable().required("Required"),
  });
  const onSubmit = (values) => {
    dispatch(
      addFormulaNote(formulaId, values.note, () => {
        dispatch(getCustomFormula());
      })
    );

    setNoteContent(values.note);
    setShowAddSection(false);
  };
  return (
    <Modal size="xl" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Formula Note</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <>
          {noteContent ? (
            <>
              <p className="page-desc">{noteContent}</p>
            </>
          ) : (
            <p className="page-desc">No Note</p>
          )}

          {showAddSection ? (
            <div>
              {" "}
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ errors, touched }) => {
                  return (
                    <Form>
                      <div className="row">
                        <div className="col-sm-12">
                          <FormikControl
                            control="textarea"
                            label="Note: "
                            name="note"
                            rows="4"
                            placeholder="Enter Note about formula here"
                            hasError={errors.note && touched.note}
                          />
                        </div>
                        <div className="action-btn-wrapper row ml-3">
                          <button
                            className="btn-orange btn-table"
                            type="submit"
                          >
                            {" "}
                            Save
                          </button>
                          <button
                            className="btn-orange btn-table btn-black"
                            onClick={() => setShowAddSection(false)}
                          >
                            {" "}
                            Cancel
                          </button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          ) : (
            <>
              {noteContent ? (
                <button
                  className="btn-orange btn-table"
                  onClick={() => setShowAddSection(true)}
                >
                  Edit
                </button>
              ) : (
                <button
                  className="btn-orange btn-table"
                  onClick={() => setShowAddSection(true)}
                >
                  Add
                </button>
              )}
            </>
          )}
        </>
      </Modal.Body>
    </Modal>
  );
};
export default NotePopup;
